var _path, _mask, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.404 13.0736H4.70763C3.9533 13.0736 3.3418 12.4621 3.3418 11.7077V4.87853C3.3418 4.1242 3.9533 3.5127 4.70764 3.5127H9.14661H13.5856C14.3399 3.5127 14.9514 4.1242 14.9514 4.87853V7.65574",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2204_42277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8535,
    y: 6.92676,
    width: 6.14627,
    height: 9.56087,
    rx: 1.36584
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8535,
    y: 6.92676,
    width: 6.14627,
    height: 9.56087,
    rx: 1.36584,
    stroke: "#172664",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_2204_42277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.373C2.58579 14.373 2.25 14.7088 2.25 15.123C2.25 15.5373 2.58579 15.873 3 15.873V14.373ZM3 15.123V15.873H11.195V15.123V14.373H3V15.123Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellClients);
export default __webpack_public_path__ + "static/media/icn_table_cell_Clients.2bdb6ad93337c7f202639da275772e75.svg";
export { ForwardRef as ReactComponent };